import { render } from "./Withdrawals.vue?vue&type=template&id=1926ca84&scoped=true&ts=true"
import script from "./Withdrawals.vue?vue&type=script&lang=ts"
export * from "./Withdrawals.vue?vue&type=script&lang=ts"

import "./Withdrawals.vue?vue&type=style&index=0&id=1926ca84&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1926ca84"]])

export default __exports__